// TypingIndicator.js
import React from 'react';
import '../styles/UserInput.scss';

const TypingIndicator = () => (
  <div className="flex justify-start mb-2">
    <div
      className="max-w-[75%] md:max-w-[50%] lg:max-w-[70%] bg-callbell-light-gray rounded-tl-2xl rounded-tr-2xl rounded-br-2xl p-2 px-3"
    >
      <div className="typing-indicator flex items-center justify-center h-7">
        <span className="dot bg-gray-400"></span>
        <span className="dot bg-gray-400"></span>
        <span className="dot bg-gray-400"></span>
      </div>
    </div>
    <style jsx>{`
      .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin: 0 2px;
        animation: blink 1.4s infinite both;
      }

      @keyframes blink {
        0%, 100% { opacity: .2; }
        20% { opacity: 1; }
        80% { opacity: .2; }
      }
    `}</style>
  </div>
);

export default TypingIndicator;
